module.exports = __webpack_public_path__ + "assets/img/CY-white.11445721.png";